// Code changes v2.2, v5.4, and v5.5

if (document.querySelector('.sticky-atc') !== null) {
  var width = window.innerWidth
    || document.documentElement.clientWidth
    || document.body.clientWidth;

    const addButton = document.querySelector('.sticky-atc');


    if (width < 900) {
      var observer = new IntersectionObserver(function(entries) {
    	// isIntersecting is true when element and viewport are overlapping
    	// isIntersecting is false when element and viewport don't overlap
    	if(entries[0].isIntersecting === true) {      
          addButton.style.visibility = "hidden";
      }else {
        addButton.style.visibility = "visible";
        addButton.style.position = 'fixed';
          addButton.style.bottom = '0';
          addButton.style.left = '0';
          addButton.style.width = '100%';
          addButton.style.margin = '0px';
          addButton.style.borderRadius = 'initial';
          addButton.style.background = '#E62A2A';
          addButton.style.height = '5rem';
          //Code changes v5.1 addButton.style.zIndex = '2'
          addButton.style.zIndex = '100'
        }
    }, { threshold: [0] });

    observer.observe(document.querySelector('.button_visible'));

    // Code changes v5.5: hide sticky ATC behind the mobile menu drawer when
    // it's open, same fix as applied to the bundle summary sticky button.
    // We only touch z-index here, never visibility/display, so this can't
    // fight with the IntersectionObserver above.
    const menuDrawerDetails = document.getElementById('Details-menu-drawer-container');
    if (menuDrawerDetails) {
      const menuObserver = new MutationObserver(() => {
        if (menuDrawerDetails.hasAttribute('open')) {
          addButton.style.zIndex = '1';
        } else {
          addButton.style.zIndex = '1'; // keep low during close animation
          setTimeout(() => {
            addButton.style.zIndex = '100'; // restore after animation done
          }, 400);
        }
      });
      menuObserver.observe(menuDrawerDetails, { attributes: true, attributeFilter: ['open'] });
    }
    }
  }